// src/components/filter/Filter.js

import React, { useState, useRef, useEffect } from "react";
import { Input, Row, Select, Col, Spin } from "antd";
import debounce from "lodash.debounce";

const { Option } = Select;

const Filter = ({
  searchPlaceholder,
  optionsLists,
  data = {},
  onSelect,
  onSearchValue,
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const debouncedSearchRef = useRef();

  // Initialisation du debounce pour la barre de recherche principale uniquement
  useEffect(() => {
    if (typeof onSearchValue === 'function') {
      debouncedSearchRef.current = debounce((value, key) => {
        onSearchValue(value, key);
      }, 600);
      return () => {
        if (debouncedSearchRef.current) debouncedSearchRef.current.cancel();
      };
    }
  }, [onSearchValue]);

  const handleSearch = (value, key) => {
    if (debouncedSearchRef.current) {
      debouncedSearchRef.current(value, key);
    }
  };

  // Configuration de la grille (4 éléments par ligne sur grand écran)
  const colProps = {
    xs: 24,
    sm: 12,
    md: 8,
    lg: 6,
    xl: 6
  };

  return (
    <Row gutter={[16, 16]} align="middle">
      
      {/* BARRE DE RECHERCHE GÉNÉRALE (si fournie) */}
      {searchPlaceholder && (
        <Col {...colProps}> 
          <Input
            placeholder={searchPlaceholder}
            onChange={(e) => {
              setSearchTerm(e.target.value);
              handleSearch(e.target.value, "search"); // Utilise la recherche globale
            }}
            value={searchTerm}
            style={{ width: "100%" }}
            allowClear
          />
        </Col>
      )}

      {/* GÉNÉRATION DES MENUS DÉROULANTS (Délégués, Médecins, etc.) */}
      {optionsLists?.map((optionList) => (
        <Col key={optionList.key} {...colProps}>
          <Select
            placeholder={optionList.placeholder}
            mode={optionList.multiple ? "multiple" : undefined}
            loading={optionList.isLoading}
            notFoundContent={optionList.isLoading ? <Spin size="small" /> : "Aucune donnée"}
            
            // Gestion de la sélection
            onChange={(values, option) => {
              if (typeof onSelect === 'function') {
                const selectedAntDOptions = Array.isArray(option) ? option : (option ? [option] : []);
                const selectedIds = selectedAntDOptions.map(opt => opt && opt.key).filter(Boolean); 
                onSelect(values, optionList.key, selectedIds);
              }
            }}
            
            value={data[optionList.key] || (optionList.multiple ? [] : undefined)}
            style={{ width: "100%" }}
            
            // --- CORRECTION : Suppression de onSearch pour éviter le filtrage global pendant la frappe ---
            // On laisse showSearch=true pour permettre de chercher DANS la liste
            showSearch={true}
            allowClear
            
            // Filtrage local (dans le navigateur) pour trouver un élément dans la liste
            filterOption={(input, option) => {
                const label = option.label ? String(option.label) : (option.children ? String(option.children) : '');
                return label.toLowerCase().includes(input.toLowerCase());
            }}
          >
            {optionList.options?.map((opt) => (
              <Option 
                key={opt.id || opt.value} 
                value={opt.value}
                label={opt.label} 
              >
                {opt.label}
              </Option>
            ))}
          </Select>
        </Col>
      ))}
    </Row>
  );
};

export default Filter;